import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('microservice_token');


export const getDrugAllergyGene = (token, platform) => {
    return new Promise(resolve => {
        let url = `/api/v1/microservice/lab/getDrugAllergyGene?platform=${platform}`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': token
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}
export const getDrugDegradingGene = (token, platform) => {
    return new Promise(resolve => {
        let url = `/api/v1/microservice/lab/getDrugDegradingGene?platform=${platform}`
        let header = {
            'Content-Type': 'application/json',
            'Authorization': token
        }
        axios.get(url, { headers: header }).then(res => {
            resolve(res)
        }).catch(() => {
            resolve(false)
        })
    })
}